import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMIB.module.css"
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";
import Input from "../../../../../../../components/textbox/Input";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import $ from 'jquery';
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json"

class StatoVaccinaleMIB extends React.Component {

    state = {
        statoVaccinale: {
            agente: this.props.statePadre && this.props.statePadre.agente ? this.props.statePadre.agente : "",
            dose1: this.props.statePadre && this.props.statePadre.dose1 ? this.props.statePadre.dose1 : "",
            dose2: this.props.statePadre && this.props.statePadre.dose2 ? this.props.statePadre.dose2 : "",
            dose3: this.props.statePadre && this.props.statePadre.dose3 ? this.props.statePadre.dose3 : "",
            data1: this.props.statePadre && this.props.statePadre.data1 ? this.props.statePadre.data1 : "",
            data2: this.props.statePadre && this.props.statePadre.data2 ? this.props.statePadre.data2 : "",
            data3: this.props.statePadre && this.props.statePadre.data3 ? this.props.statePadre.data3 : "",
            nome1: this.props.statePadre && this.props.statePadre.nome1 ? this.props.statePadre.nome1 : "",
            nome2: this.props.statePadre && this.props.statePadre.nome2 ? this.props.statePadre.nome2 : "",
            nome3: this.props.statePadre && this.props.statePadre.nome3 ? this.props.statePadre.nome3 : "",
            note: this.props.statePadre && this.props.statePadre.note ? this.props.statePadre.note : "",
            corretto: []
        },
        malattiaBatterica: ""
    }

    constructor(props) {
        super(props)

        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.riceviValore = this.riceviValore.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.validate = this.validate.bind(this);
        this.disabledDate = this.disabledDate.bind(this);


    }

    componentDidMount() {
        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setStatoVaccinaleMIB(this.state.statoVaccinale, "", oggetto)

        if (Utils.isEmpty(this.props.statePadre)) {
            if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.statoVaccinaleMIB) {
                let statoVaccinale = this.state.statoVaccinale
                let statoVaccinaleProps = this.props.segnalazioneCopia.schedaSpeciale.statoVaccinaleMIB

                statoVaccinale.agente = statoVaccinaleProps.agente ? statoVaccinaleProps.agente : this.state.statoVaccinale.agente
                statoVaccinale.dose1 = statoVaccinaleProps.dose1 ? statoVaccinaleProps.dose1 : this.state.statoVaccinale.dose1
                statoVaccinale.dose2 = statoVaccinaleProps.dose2 ? statoVaccinaleProps.dose2 : this.state.statoVaccinale.dose2
                statoVaccinale.dose3 = statoVaccinaleProps.dose3 ? statoVaccinaleProps.dose3 : this.state.statoVaccinale.dose3
                statoVaccinale.data1 = statoVaccinaleProps.data1 ? statoVaccinaleProps.data1 : this.state.statoVaccinale.data1
                statoVaccinale.data2 = statoVaccinaleProps.data2 ? statoVaccinaleProps.data2 : this.state.statoVaccinale.data2
                statoVaccinale.data3 = statoVaccinaleProps.data3 ? statoVaccinaleProps.data3 : this.state.statoVaccinale.data3
                statoVaccinale.nome1 = statoVaccinaleProps.nome1 ? statoVaccinaleProps.nome1 : this.state.statoVaccinale.nome1
                statoVaccinale.nome2 = statoVaccinaleProps.nome2 ? statoVaccinaleProps.nome2 : this.state.statoVaccinale.nome2
                statoVaccinale.nome3 = statoVaccinaleProps.nome3 ? statoVaccinaleProps.nome3 : this.state.statoVaccinale.nome3
                statoVaccinale.note = statoVaccinaleProps.note ? statoVaccinaleProps.note : this.state.statoVaccinale.note

                this.setState({statoVaccinale: statoVaccinale});
            }
        }

        this.controlloDati()
        oggetto = this.createOggettoBE()
        this.props.setStatoVaccinaleMIB(this.state.statoVaccinale, "", oggetto)

        this.disabledDate()

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.malattiaBatterica !== this.props.malattiaBatterica) {
            this.setState({malattiaBatterica: this.props.malattiaBatterica})
            this.controlloDati()
        }
        if (prevState !== this.state) {
            let res = this.createOggettoBE()
            this.props.setStatoVaccinaleMIB(this.state.statoVaccinale, this.validate(), res)
        }

        this.disabledDate()
    }

    disabledDate() {

        if (this.state.statoVaccinale.agente === "2") {
            $(document).ready(function () {
                $("#data1").datepicker('enable');
                $("#data2").datepicker('enable');
                $("#data3").datepicker('enable');
            })

        } else {
            $(document).ready(function () {
                $("#data1").datepicker('disable');
                $("#data2").datepicker('disable');
                $("#data3").datepicker('disable');
            })
        }
    }

    validate() {

        if (this.state.statoVaccinale.data1 && Utils.validateDate(this.state.statoVaccinale.data1, "Messages.DataSomministrazione", "Messages.DataSomministrazioneOdierna")) {
            return Utils.validateDate(this.state.statoVaccinale.data1, "Messages.DataSomministrazione", "Messages.DataSomministrazioneOdierna")
        }
        if (this.state.statoVaccinale.data2 && Utils.validateDate(this.state.statoVaccinale.data2, "Messages.DataSomministrazione", "Messages.DataSomministrazioneOdierna")) {
            return Utils.validateDate(this.state.statoVaccinale.data2, "Messages.DataSomministrazione", "Messages.DataSomministrazioneOdierna")
        }
        if (this.state.statoVaccinale.data3 && Utils.validateDate(this.state.statoVaccinale.data3, "Messages.DataSomministrazione", "Messages.DataSomministrazioneOdierna")) {
            return Utils.validateDate(this.state.statoVaccinale.data3, "Messages.DataSomministrazione", "Messages.DataSomministrazioneOdierna")
        }

        return ""

    }

    createOggettoBE() {
        let statoVaccinale = JSON.parse(JSON.stringify(this.state.statoVaccinale))
        let statoVaccinaleBe = Utils.removeEmptyValueFromObject(statoVaccinale)
        return Utils.removeFieldFromObject(statoVaccinaleBe, "corretto")

    }

    controlloDati() {
        let statoVaccinale = this.state.statoVaccinale
        statoVaccinale.corretto = []

        if (this.props.malattiaBatterica && this.props.malattiaBatterica !== "malattiaBatterica4") {
            if (!statoVaccinale.agente) statoVaccinale.corretto[0] = "Campo \"Vaccinato per l'agente in causa?\" mancante";
            else if (statoVaccinale.agente === "2") {
                if (!statoVaccinale.dose1 || !statoVaccinale.data1 || (statoVaccinale.data1 && Utils.isDateInValid(Utils.transformDateForBackend(statoVaccinale.data1), "-")) || !statoVaccinale.nome1) {
                    statoVaccinale.corretto[0] = "Campo \"Se 'Si, regolarmente o parzialmente', compilare la tabella seguente solo per la vaccinazione contro l'agente responsabile del caso\" mancante";
                } else {
                    statoVaccinale.corretto = [];
                    if (statoVaccinale.dose2 && statoVaccinale.data2 && !Utils.isDateInValid(Utils.transformDateForBackend(statoVaccinale.data2), "-") && statoVaccinale.nome2 || (!statoVaccinale.dose2 && (!statoVaccinale.data2 || (statoVaccinale.data2 && Utils.isDateInValid(Utils.transformDateForBackend(statoVaccinale.data2), "-"))) && !statoVaccinale.nome2)) {
                        statoVaccinale.corretto = [];
                        if (statoVaccinale.dose2 && statoVaccinale.data2 && !Utils.isDateInValid(Utils.transformDateForBackend(statoVaccinale.data2), "-") && statoVaccinale.nome2 && statoVaccinale.dose3 && statoVaccinale.data3 && !Utils.isDateInValid(Utils.transformDateForBackend(statoVaccinale.data3), "-") && statoVaccinale.nome3 || (!statoVaccinale.dose3 && (!statoVaccinale.data3 || (statoVaccinale.data3 && Utils.isDateInValid(Utils.transformDateForBackend(statoVaccinale.data3), "-"))) && !statoVaccinale.nome3)) {
                            statoVaccinale.corretto = [];
                        } else {
                            statoVaccinale.corretto[0] = "Campo \"Se 'Si, regolarmente o parzialmente', compilare la tabella seguente solo per la vaccinazione contro l'agente responsabile del caso\" mancante";
                        }
                    } else {
                        statoVaccinale.corretto[0] = "Campo \"Se 'Si, regolarmente o parzialmente', compilare la tabella seguente solo per la vaccinazione contro l'agente responsabile del caso\" mancante";
                    }
                }
            }
        }

        this.setState({statoVaccinale: statoVaccinale})

    }

    riceviValoreRadioButton(event, field) {
        let statoVaccinale = this.state.statoVaccinale
        statoVaccinale[field] = event

        if (event !== "2" && field === "agente") {
            for (let key in statoVaccinale) {
                if (key !== "agente" && key !== "note" && key !== "corretto") {
                    statoVaccinale[key] = ""
                }
            }
        }

        this.setState({statoVaccinale: statoVaccinale})

        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setStatoVaccinaleMIB(this.state.statoVaccinale, "", oggetto)
    }

    riceviValore(field, event) {
        let statoVaccinale = this.state.statoVaccinale

        if (field.currentTarget) {
            statoVaccinale[field.currentTarget.id] = field.currentTarget.value
        } else {
            statoVaccinale[field] = event.target.value
        }
        this.setState({statoVaccinale: statoVaccinale})

        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setStatoVaccinaleMIB(this.state.statoVaccinale, "", oggetto)

    }


    render() {

        const {t} = this.props;

        const sezione1 = (

            <div>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.MIB.StatoVaccinale.titolo")}
                        {this.state.malattiaBatterica !== "" && this.props.malattiaBatterica !== "malattiaBatterica4" ?
                            <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}
                    </h6>
                    <hr className={stylesWelcome.hr}/>
                </div>

                <div className={"container"}>
                    <div className="row" style={{marginTop: "1rem"}}>

                        <div className={"col-lg-5"}>
                            <p style={{marginTop: "10px"}}>{t("SchedaFlussoSpeciale.MIB.StatoVaccinale.1")}</p>
                        </div>

                        <div style={{marginRight: "1rem"}}>
                            <RadioButton id={"agente1"}
                                         name={"agente"}
                                         style={{color: "black", fontSize: "16px"}}
                                         label={t("SchedaFlussoSpeciale.MIB.StatoVaccinale.2")}
                                         value={"0"}
                                         onClick={() => this.riceviValoreRadioButton("1", "agente")}
                                         checked={this.state.statoVaccinale.agente === "1"}
                            />
                        </div>
                        <div style={{marginRight: "1rem"}}>
                            <RadioButton id={"agente2"}
                                         name={"agente"}
                                         style={{color: "black", fontSize: "16px"}}
                                         label={t("SchedaFlussoSpeciale.MIB.StatoVaccinale.3")}
                                         value={"0"}
                                         onClick={() => this.riceviValoreRadioButton("2", "agente")}
                                         checked={this.state.statoVaccinale.agente === "2"}
                            />
                        </div>
                        <div style={{marginRight: "1rem"}}>
                            <RadioButton id={"agente3"}
                                         name={"agente"}
                                         style={{color: "black", fontSize: "16px"}}
                                         label={t("SchedaFlussoSpeciale.MIB.StatoVaccinale.4")}
                                         value={"0"}
                                         onClick={() => this.riceviValoreRadioButton("3", "agente")}
                                         checked={this.state.statoVaccinale.agente === "3"}
                            />
                        </div>
                    </div>
                </div>
            </div>

        );

        const sezione2 = (

            <div className={"container"}>
                <div className="row">
                    <div className={"col-lg-12"}>
                        <p style={{marginTop: "10px"}}>{t("SchedaFlussoSpeciale.MIB.StatoVaccinale.tabella")}</p>
                    </div>
                    <div className={"col-lg-7"} style={{marginTop: "1rem"}}>
                        <table className="table table-bordered">
                            <thead>
                            <tr className="table-info">
                                {/*<th scope="col">#</th>*/}
                                <td scope="col">{t("SchedaFlussoSpeciale.MIB.StatoVaccinale.tabella1")}
                                    {(this.state.statoVaccinale.agente === "2") ?
                                        <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}
                                </td>
                                <td scope="col">{t("SchedaFlussoSpeciale.MIB.StatoVaccinale.tabella2")}
                                    {(this.state.statoVaccinale.agente === "2") ?
                                        <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}
                                </td>
                                <td scope="col">{t("SchedaFlussoSpeciale.MIB.StatoVaccinale.tabella3")}
                                    {(this.state.statoVaccinale.agente === "2") ?
                                        <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}
                                </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                                        <Input
                                            id={"dose1"}
                                            onChange={this.riceviValore}
                                            field={"dose1"}
                                            value={this.state.statoVaccinale.dose1}
                                            placeholder={t("SchedaFlussoSpeciale.MIB.StatoVaccinale.tabella1")}
                                            disabled={this.state.statoVaccinale.agente !== "2"}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className={`col-lg-11 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                        <Calendar
                                            id={"data1"}
                                            value={this.state.statoVaccinale.data1}
                                            field={"data1"}
                                            onChange={this.riceviValore}
                                            errorMessage={"Data non valida"}
                                            error={(this.state.statoVaccinale.data1 === "" || this.state.statoVaccinale.data1 == null) ? false :
                                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.statoVaccinale.data1), "-")
                                            }
                                            disabled={this.state.statoVaccinale.agente !== "2"}
                                        >
                                        </Calendar>
                                    </div>
                                </td>
                                <td>
                                    <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                        <Input
                                            id={"nome1"}
                                            onChange={this.riceviValore}
                                            field={"nome1"}
                                            value={this.state.statoVaccinale.nome1}
                                            placeholder={t("SchedaFlussoSpeciale.MIB.StatoVaccinale.tabella3")}
                                            disabled={this.state.statoVaccinale.agente !== "2"}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                                        <Input
                                            id={"dose2"}
                                            onChange={this.riceviValore}
                                            field={"dose2"}
                                            value={this.state.statoVaccinale.dose2}
                                            placeholder={t("SchedaFlussoSpeciale.MIB.StatoVaccinale.tabella1")}
                                            disabled={this.state.statoVaccinale.agente !== "2"}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className={`col-lg-11 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                        <Calendar
                                            id={"data2"}
                                            value={this.state.statoVaccinale.data2}
                                            field={"data2"}
                                            onChange={this.riceviValore}
                                            errorMessage={"Data non valida"}
                                            error={(this.state.statoVaccinale.data2 === "" || this.state.statoVaccinale.data2 == null) ? false :
                                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.statoVaccinale.data2), "-")
                                            }
                                            disabled={this.state.statoVaccinale.agente !== "2"}
                                        >
                                        </Calendar>
                                    </div>
                                </td>
                                <td>
                                    <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                        <Input
                                            id={"nome2"}
                                            onChange={this.riceviValore}
                                            field={"nome2"}
                                            value={this.state.statoVaccinale.nome2}
                                            placeholder={t("SchedaFlussoSpeciale.MIB.StatoVaccinale.tabella3")}
                                            disabled={this.state.statoVaccinale.agente !== "2"}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                                        <Input
                                            id={"dose3"}
                                            onChange={this.riceviValore}
                                            field={"dose3"}
                                            value={this.state.statoVaccinale.dose3}
                                            placeholder={t("SchedaFlussoSpeciale.MIB.StatoVaccinale.tabella1")}
                                            disabled={this.state.statoVaccinale.agente !== "2"}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className={`col-lg-11 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                        <Calendar
                                            id={"data3"}
                                            value={this.state.statoVaccinale.data3}
                                            field={"data3"}
                                            onChange={this.riceviValore}
                                            errorMessage={"Data non valida"}
                                            error={(this.state.statoVaccinale.data3 === "" || this.state.statoVaccinale.data3 == null) ? false :
                                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.statoVaccinale.data3), "-")
                                            }
                                            disabled={this.state.statoVaccinale.agente !== "2"}
                                        >
                                        </Calendar>
                                    </div>
                                </td>
                                <td>
                                    <div className={`${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                                        <Input
                                            id={"nome3"}
                                            onChange={this.riceviValore}
                                            field={"nome3"}
                                            value={this.state.statoVaccinale.nome3}
                                            placeholder={t("SchedaFlussoSpeciale.MIB.StatoVaccinale.tabella3")}
                                            disabled={this.state.statoVaccinale.agente !== "2"}
                                        />
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        );

        const sezione3 = (
            <div className={"container"} style={{marginTop: "1rem"}}>

                <div className="row">
                    <div className="col-lg-6">
                        <p style={{color: "#1b7ea9"}}>
                            {t("SchedaFlussoSpeciale.MIB.StatoVaccinale.note")}
                        </p>
                        <Input type={"textarea"} class="form-group" rows="3"
                               id={"note"}
                               onChange={this.riceviValore}
                               field={"note"}
                               value={this.state.statoVaccinale.note}
                               placeholder={t("SchedaFlussoSpeciale.MIB.StatoVaccinale.note")}>
                        </Input>
                    </div>
                    <p style={{fontWeight: "bold", fontSize: "12px"}}>
                        {t("SchedaFlussoSpeciale.MIB.StatoVaccinale.note1")}
                    </p>
                    <p style={{fontWeight: "bold", fontSize: "12px"}}>
                        {t("SchedaFlussoSpeciale.MIB.StatoVaccinale.note2")}
                    </p>
                </div>

            </div>

        );

        return (
            <div>
                {sezione1}
                {sezione2}
                {sezione3}
            </div>

        )
    }

}

export default withTranslation('common')(StatoVaccinaleMIB)
